import React from "react";
import { connect } from "react-redux";

import _get from "lodash/get";

export default function requiresAuthentication(Component) {
    class AuthenticatedComponent extends React.Component {
        componentWillMount() {
            this.checkAuth(this.props);
        }

        componentWillReceiveProps(nextProps) {
            this.checkAuth(nextProps);
        }

        checkAuth(props) {
            if (!props.isAuthenticated) {
                return props.history.push("/login", {
                    redirectAfterLogin: props.redirectAfterLogin
                });
            }
        }

        render() {
            if (this.props.isAuthenticated) {
                return <Component {...this.props} />;
            } else {
                return null;
            }
        }
    }

    function mapStateToProps(state) {
        const redirectAfterLogin = _get(
            state.router.location.state,
            "redirectAfterLogin"
        );
        const isAuthenticated = !state.session.authRequired;
        const authenticatedUser =
            isAuthenticated && state.entities.users[state.session.userId];
        return {
            authenticatedUser,
            location: state.router.location,
            isAuthenticated,
            redirectAfterLogin
        };
    }

    return connect(mapStateToProps)(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/utils/requiresAuthentication.js